import { SMETIO_UNKNOWN_ERROR } from "../../constants/smetio_general_constants";
import { SMETIO_GEOLOCATION_UNAVAILABLE, SMETIO_PERMISSION_DENIED } from "../../constants/smetio_geolocation_constants";

/**** EVERY CLASS USING THIS FUNCTION HAS TO IMPLEMENT this.showGeolocationError METHOD ****/
export function handleGeolocationError() {

    switch(window.smetioVisitor.geoLocation.currentError) {
  
        case SMETIO_PERMISSION_DENIED:          
            this.showGeolocationError({
              txt: "txt256",
              error: SMETIO_PERMISSION_DENIED
            });            
          break;

        case SMETIO_GEOLOCATION_UNAVAILABLE:       
            this.showGeolocationError({
              txt: "txt257",
              error: SMETIO_GEOLOCATION_UNAVAILABLE
            });             
          break;

        default: 
            this.showGeolocationError({
              txt: "txt219",
              error: SMETIO_UNKNOWN_ERROR
            });          
        break; 
      };      

};
